/* Page motion: reveal-on-scroll and timers that stop when
   the user leaves the screen. Everything degrades to static content when the
   user prefers reduced motion. */

export const reducedMotion = (): boolean =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* Cleanups for the current screen; the router runs them before drawing the next. */
let cleanups: (() => void)[] = [];

export function onLeave(fn: () => void): void {
  cleanups.push(fn);
}

export function leaveScreen(): void {
  for (const fn of cleanups) fn();
  cleanups = [];
}

/** setInterval that stops with the screen. */
export function every(ms: number, fn: () => void): void {
  const id = window.setInterval(fn, ms);
  onLeave(() => window.clearInterval(id));
}

/** Elements marked data-reveal fade up as they enter the viewport. */
export function reveal(root: HTMLElement): void {
  const items = root.querySelectorAll<HTMLElement>("[data-reveal]");
  if (reducedMotion() || !("IntersectionObserver" in window)) {
    items.forEach((el) => el.classList.add("in"));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const el = entry.target as HTMLElement;
        el.classList.add("in");
        observer.unobserve(el);
      }
    },
    { threshold: 0.15, rootMargin: "0px 0px -40px 0px" },
  );
  items.forEach((el) => observer.observe(el));
  onLeave(() => observer.disconnect());
}
